import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const MentionsLegales = () => {
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const sections = t('legal.sections');

  return (
    <div className={`min-h-screen transition-colors duration-500 ${
      isDark ? 'bg-[#0D0D0D]' : 'bg-[#FAF7F0]'
    }`}>
      <Header />
      
      <main className="pt-32 pb-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl mx-auto">
          {/* Back Link */}
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#F5E6A3] transition-colors duration-300 mb-12 text-sm"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('legal.backToHome')}
          </Link>

          {/* Title */}
          <h1 
            data-testid="legal-title"
            className={`font-playfair text-4xl md:text-5xl mb-12 ${
              isDark ? 'text-white' : 'text-[#1A1A1A]'
            }`}
          >
            {t('legal.title')}
          </h1>

          {/* Content */}
          <div className="space-y-12">
            {sections && typeof sections === 'object' && Object.entries(sections).map(([key, section]) => (
              <div key={key} className={`border-b pb-8 ${
                isDark ? 'border-white/5' : 'border-[#D4AF37]/20'
              }`}>
                <h2 className={`font-playfair text-xl md:text-2xl mb-4 ${
                  isDark ? 'text-white' : 'text-[#1A1A1A]'
                }`}>
                  {section.title}
                </h2>
                <p className={`leading-relaxed whitespace-pre-line ${
                  isDark ? 'text-[#F8F5EE]/70' : 'text-[#1A1A1A]/70'
                }`}>
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default MentionsLegales;